module.exports = __webpack_public_path__ + "static/media/ic_fingerprint.9a45bc83.png";